import { GenericObject } from '@cp/src/types/CommonConstans';

const getPathParams = (pathTemplate): Record<string, string> => {
  const pathname = window.location?.pathname?.trim?.();

  // Cache the split operations and check if lengths match early
  const pathSegments = pathname.split('/');
  const templateSegments = pathTemplate.split('/');

  if (pathSegments.length !== templateSegments.length) {
    return {}; // Return early if lengths don't match
  }

  const params: GenericObject = {};
  for (let i = 0; i < templateSegments.length; i++) {
    const templateSegment = templateSegments[i]?.trim?.();

    // Only process template segments that are parameters (starting with ':')
    if (templateSegment[0] === ':') {
      const paramName = templateSegment.slice(1);
      params[paramName] = pathSegments[i]?.trim?.();
    }
  }

  return params;
};

export default getPathParams;
